import { render, staticRenderFns } from "./availability_v0.vue?vue&type=template&id=48fd5b9c&scoped=true"
import script from "./availability_v0.vue?vue&type=script&lang=js"
export * from "./availability_v0.vue?vue&type=script&lang=js"
import style0 from "./availability_v0.vue?vue&type=style&index=0&id=48fd5b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd5b9c",
  null
  
)

export default component.exports